import {styled} from "@mui/material/styles";

// Ausserhalb der Funktion, sonst entsteht bei jedem Rendern eine neue Komponente und der Inhalt wird komplett neu aufgebaut.
const DhDiv = styled('div')(({ theme }) => ({
    display: 'none',
    [theme.breakpoints.up("md")]: {
        display: 'block',
    },
}));

export default function DHDesktopDiv ({comp}) {
    return <DhDiv>{comp}</DhDiv>
}
